import getIn from 'transmute/getIn';
import { FIRST_MESSAGE_ID, GENERIC_CHANNEL_ID, MESSAGE_ID, TIMESTAMP } from '../constants/genericChannelsUsedKeyPaths';
export const getUsedFirstMessageId = getIn(FIRST_MESSAGE_ID);
export const getUsedGenericChannelId = getIn(GENERIC_CHANNEL_ID);
export const getUsedMessageId = getIn(MESSAGE_ID);
export const getUsedTimestamp = getIn(TIMESTAMP);